import m from "../../geodata/es2015/bosniaHerzegovinaHigh";
window.am4geodata_bosniaHerzegovinaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bosniaHerzegovinaHigh.js
// module id = null
// module chunks = 